export default __webpack_public_path__ + "static/media/em_tshirt_1.2608bdf9.png";